module.exports = __webpack_public_path__ + "media/images/badges/yogasix/february/HeartBadges-14-e6246de00fed0c6bb7479eb3db674ca5.png";